/**
 * useEVSimulation Hook
 *
 * Encapsulates project-level simulation (not per-scenario).
 */

import { useState, useCallback } from 'react';
import { useAuth } from '@vortx/shared-ui';
import * as evService from '@vortx/shared-ui/src/services/evProjectService';

export function useEVSimulation(projectId) {
    const { currentUser } = useAuth();

    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const runSimulation = useCallback(async () => {
        if (!currentUser || !projectId) return;

        try {
            setLoading(true);
            setError(null);
            const data = await evService.simulateProject(projectId, currentUser);
            setResults(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [currentUser, projectId]);

    return { results, loading, error, runSimulation };
}
